import { CORE_URL } from "@/constants/api";
import { VITE_CORE_API_URL } from "@/constants/env";
import { auth } from "@/services/auth-service";
import { useUserStore } from "@/stores/user-store";
import axios from "axios";

export interface ServiceChannelAssetType {
	id: number;
	name: string;
	trade: string;
}

export const getServiceChannelAssetTypes = async (): Promise<
	ServiceChannelAssetType[]
> => {
	const firebaseUser = auth?.currentUser;
	if (!firebaseUser) {
		throw new Error("No authenticated user");
	}

	const token = await firebaseUser.getIdToken();
	if (!token) {
		throw new Error("Failed to get authentication token");
	}

	const user = useUserStore.getState().user;
	if (!user?.organization?.id) {
		throw new Error("No organization found for user");
	}

	try {
		const response = await axios.get(
			`${VITE_CORE_API_URL}${CORE_URL}/organization/asset-type-mappings/${user.organization.id}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);

		if (!response.data?.success) {
			throw new Error("Failed to fetch asset type mappings");
		}

		return response.data.data.serviceChannelAssetTypes.map((type: any) => ({
			id: type.id,
			name: type.name,
			trade: type.trade,
		}));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			const status = error.response?.status;
			const data = error.response?.data;
			console.error("Core API Error:", {
				status,
				data,
				message: error.message,
				url: error.config?.url,
			});

			if (status === 401) {
				throw new Error("Authentication failed");
			} else if (status === 403) {
				throw new Error("Access denied");
			} else if (status === 404) {
				throw new Error("Endpoint not found");
			} else if (status === 503) {
				throw new Error("Service temporarily unavailable");
			} else {
				throw new Error(`API error: ${error.message} (Status: ${status})`);
			}
		}
		throw error;
	}
};
